 import React, { useEffect, useState } from "react";
import {
  getAllPlansAdmin,
  createPlan,
  updatePlan,
  deletePlan,
} from "../../services/plans/adminPlansService";
import { useTranslation } from "react-i18next";

import { useLoading } from "../../components/LoadingProvider";
import LanguageDropdown from "../../components/LanguageDropdown";
// import LanguageFlag from "../../components/LanguageFlag";

import  LanguageFlag, { CurrencyFlag }  from "../../components/LanguageFlag";



import Util  from '../../components/Util'


const PlansAdmin = () => {
 
  const initialFormState = () => ({
    name: "",
    price: "",
    priceUnit: 0,
    durationDays: "",
    maxReminders: "",
    description: "",
    isActive: true,
    isFreePlan: false,
    language: "fa",
  });

  const { t } = useTranslation();
  const [plans, setPlans] = useState([]);
  const [formData, setFormData] = useState(initialFormState());
  const [editId, setEditId] = useState(null);

  const { toast } = useLoading();

//   const BASE_URL = process.env.REACT_APP_BASE_URL;


  const fetchPlans = async () => {
    const res = await getAllPlansAdmin();
    setPlans(res);
  };

  useEffect(() => {
    fetchPlans();
  }, []);

 
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      price: + Util.toEnglishDigits(formData.price),
      durationDays: +Util.toEnglishDigits(formData.durationDays),
      maxReminders: +Util.toEnglishDigits(formData.maxReminders),
      priceUnit: +formData.priceUnit,
    };

    try {
      if (editId) {
        const resp = await updatePlan(editId, payload);
      } else {
        const resp = await createPlan(payload);
      }
      setFormData(initialFormState());
      setEditId(null);
      fetchPlans();
    } catch (err) {
      alert(err.message);
    }
  };

  const handleEdit = (plan) => {
    setFormData({ ...plan });
    setEditId(plan._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm(t("confirmDelete"))) {
      await deletePlan(id);
      fetchPlans();
    }
  };

  const resetForm = () => {
        setFormData(initialFormState());
        setEditId(null);

  };

  return (
    <div className="container">
      <h2>{t("console.plans.form.title")}</h2>

      <form onSubmit={handleSubmit} className="row g-3 my-4">
        <div className="col-md-4">
          <label className="form-label">{t("console.plans.form.name")}</label>
          <input
            type="text"
            className="form-control"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">{t("console.plans.form.price")}</label>
          <input
            type="text"
            className="form-control"
            value={formData.price}
            onChange={(e) => setFormData({ ...formData, price: e.target.value })}
            required
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">{t("console.plans.form.priceUnit")}</label>
          <select
            className="form-select"
            value={formData.priceUnit}
            onChange={(e) => setFormData({ ...formData, priceUnit: e.target.value })}
          >
            <option value={0}>{t("console.plans.form.units.irr")}</option>
            <option value={1}>{t("console.plans.form.units.usd")}</option>
            <option value={2}>{t("console.plans.form.units.eur")}</option>
            <option value={3}>{t("console.plans.form.units.aed")}</option>
          </select>
        </div>

        <div className="col-md-4">
          <label className="form-label">{t("console.plans.form.durationDays")}</label>
          <input
            type="number"
            className="form-control"
            value={formData.durationDays}
            onChange={(e) =>
              setFormData({ ...formData, durationDays: e.target.value })
            }
            required
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">{t("console.plans.form.maxReminders")}</label>
          <input
            type="number"
            className="form-control"
            value={formData.maxReminders}
            onChange={(e) =>
              setFormData({ ...formData, maxReminders: e.target.value })
            }
            required
          />
        </div>

        <div className="col-md-4">
          {/* <label className="form-label">{t("plans.language")}</label>
          <select
            className="form-select"
            value={formData.language}
            onChange={(e) =>
              setFormData({ ...formData, language: e.target.value })
            }
          >
            <option value="fa">{t("languages.fa")}</option>
            <option value="en">{t("languages.en")}</option>
            <option value="ar">{t("languages.ar")}</option>
          </select> */}

           <LanguageDropdown
                defaultValue={formData.language}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, language: value }))
                }
              />

        </div>

        <div className="col-md-6">
          <label className="form-label">{t("console.plans.form.description")}</label>
          <textarea
            className="form-control"
            value={formData.description}
            rows={5}
            placeholder="each line a short feature"
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />
        </div>

        <div className="col-md-2 form-check mt-4">
          <input
            type="checkbox"
            className="form-check-input"
            checked={formData.isActive}
            onChange={(e) =>
              setFormData({ ...formData, isActive: e.target.checked })
            }
          />
          <label className="form-check-label">{t("console.plans.form.isActive")}</label>
        </div>

        <div className="col-md-2 form-check mt-4">
          <input
            type="checkbox"
            className="form-check-input"
            checked={formData.isFreePlan}
            onChange={(e) =>
              setFormData({ ...formData, isFreePlan: e.target.checked })
            }
          />
          <label className="form-check-label">{t("console.plans.form.isFreePlan")}</label>
        </div>

        <div className="col-12">
          <button type="submit" className="btn btn-primary">
            {editId ? t("console.plans.actions.update") : t("console.plans.actions.create")}
          </button>

           {editId && (
                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={resetForm}
                >
                  {t("console.plant.form_submit_button_cancel_edit_label")}
                </button>
              )}


        </div>
      </form>

      <hr />

      <table className="table">
        <thead>
          <tr>
            <th>{t("console.plans.form.name")}</th>
            <th> {t("console.plans.form.price")}</th>
            <th>{t("console.plans.form.durationDays")}</th>
            <th>{t("console.plans.form.maxReminders")}</th>
            <th>{t("console.plans.form.language")}</th>
            <th>{t("console.plans.form.isActive")}</th>
            <th>{t("console.plans.form.isFreePlan")}</th>
            <th>{t("console.plans.actions.actions")}</th>
          </tr>
        </thead>
        <tbody>
          {plans.map((plan) => (
            <tr key={plan._id}>
              <td>{plan.name}</td>
              <td>  {plan.price}  <span style={{ fontSize: '18px' }}>   { <CurrencyFlag currency={plan.priceUnit}  />  } </span>    </td>
              <td>{plan.durationDays}</td>
              <td>{plan.maxReminders}</td>
              <td> <span style={{ fontSize: '24px' }}> <LanguageFlag language={plan.language} /></span>   </td>
              <td>{plan.isActive ? t("console.plans.yes") : t("console.plans.no")}</td>
              <td>{plan.isFreePlan ? t("console.plans.yes") : t("console.plans.no")}</td>
              <td>
                <button
                  className="btn btn-sm btn-warning me-2"
                  onClick={() => handleEdit(plan)}
                >
                  {t("console.plans.actions.edit")}
                </button>

{/*                 
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(plan._id)}
                >
                  {t("console.plans.actions.delete")}
                </button> */}



              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlansAdmin;
